import './ProjectProfileManagement.css';
import LoadingPanel from '../common/LoadingPanel';
import { Button, Chip, FormControl, MenuItem, Select, TextField } from '@material-ui/core';
import { useEffect, useMemo, useState } from 'react';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import Utils from '@/common/utils/utils';
import Constant from '../../common/constant/Constant';
import { useSnackbar } from 'notistack';
import { userAtom } from '@/state/atom/userAtom';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { closeTabId, panelInitDataAtom } from '@/state/atom/panelAtom';
import { closePanelTabSelector, setPanelSelector, triggerReloadTicketListByPanelType } from '@/state/selector/panelSelector';
import { corporationAtom } from '@/state/atom/corporationAtom';

import { projectInuseDetailAtom, projectListInCorporationAtom, projectListInCorporationByUserIdAtom } from '@/state/atom/projectAtom';
import {
    onChangeProjectName, changeProjectName, getValueProjectServiceType, onChangeProjectServiceType, onSubmitChangeProjectProfile,
    handleCancelEditProjectProfile, getStatusUsingSynonymProject, getStatusUsingIpAddressRestrictProject, getIpAddressRangeProject, onChangeUsingIpAddressRestrict,
    onChangeIpAddressRange, changeIpAddressRange, getProjectOfEmailResponseSetting, validateSubmitProjectProfile,
    getInitTelephoneAgentSetting, getStatusUsingFileTranslationProject,
    isDisplayTelephoneHoldSettings, isDisplayFileTranslationSetting,
    getInitKBoardSystemPrompt
} from '@/component/project/handler/ProjectProfileManagementHandler';
import {
    resolveKBoardPromptTicket,
    handleOnBlurKBoardSystemPrompt,
    handleRemoveKBoardSystemPrompt
} from '@/component/common/handler/KBoardSystemPromptHandler';
import EmailResponseSetting from './EmailResponseSetting/EmailResponseSetting';
import { getPublicAPI } from '@/service/publicService';
import { updatePanelInitData } from '../multiPanel/panel/handler/PanelHandler';
import TelephoneAgentSetting from './TelephoneAgentSetting/TelephoneAgentSetting';
import { openPromptTicketPanel } from '../chatAI/handler/ChatAIHandler';
import OverflowTooltipContent from '@/component/common/OverflowTooltipContent';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function ProjectProfileManagement(props) {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const addNewPanel = useSetRecoilState(setPanelSelector);
    const [panelInitData, setPanelInitData] = useRecoilState(panelInitDataAtom);
    const reloadTicketListByPanelType = useSetRecoilState(triggerReloadTicketListByPanelType);

    const corporationDetail = useRecoilValue(corporationAtom);
    const userDetail = useRecoilValue(userAtom);
    const [projectInuseDetail, setProjectInuseDetail] = useRecoilState(projectInuseDetailAtom);
    const [listProjectInCorp, setListProjectInCorp] = useRecoilState(projectListInCorporationAtom);
    const [listProjectOfUser, setListProjectOfUser] = useRecoilState(projectListInCorporationByUserIdAtom);

    let currentProjectNameObject = Utils.convertJSONDataToObject(projectInuseDetail?.name);
    let currentProjectName = currentProjectNameObject ? Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, currentProjectNameObject) : '';
    const [projectName, setProjectName] = useState(currentProjectName);
    const [projectType, setProjectType] = useState(getValueProjectServiceType(projectInuseDetail));
    const [usingSynonym, setUsingSynonym] = useState(getStatusUsingSynonymProject(projectInuseDetail));
    const [usingFileTranslation, setUsingFileTranslation] = useState(getStatusUsingFileTranslationProject(projectInuseDetail));
    const [usingIpAddressRestrict, setUsingIpAddressRestrict] = useState(getStatusUsingIpAddressRestrictProject(projectInuseDetail));
    const [ipAddressRange, setIpAddressRange] = useState(getIpAddressRangeProject(projectInuseDetail));
    const ipAddressRangeDefault = useMemo(() => {
        return getIpAddressRangeProject(projectInuseDetail);
    }, [projectInuseDetail]);
    
    // setting email
    const [isEmailResponseSettingFunction, setIsEmailResponseSettingFunction] = useState(false)
    const [projectMail, setProjectMail] = useState({value: '', error: ''})
    const [mailSettingDefault, setMailSettingDefault] = useState({
        projectMail: '',
        projectAddressName: '',
        senderEmailAddress: '',
        ccEmailAddressList: [],
        bccEmailAddressList: [],
        signature: ''
    });
    const [projectAddressName, setProjectAddressName] = useState({value: '', error: ''})
    const [senderEmailAddress, setSenderEmailAddress] = useState({value: '', error: ''})
    const [ccEmailAddressList, setCcEmailAddressList] = useState([])
    const [bccEmailAddressList, setBccEmailAddressList] = useState([])
    const [signature, setSignature] = useState({value: '', error: ''})

    const [listSuggestSearchEmail, setListSuggestSearchEmail] = useState([])
    const [isSendEmailVerify, setIsSendEmailVerify] = useState(false)

    // setting telephone agent
    const {
        initIsUsingTelephoneAgent,
        initPhoneNumber,
        initHoldMusicFileS3Key,
        initHoldWarningTimeMinutes,
        initToolsCallTimeoutSeconds
    } = getInitTelephoneAgentSetting(projectInuseDetail);
    const [isUsingTelephoneAgent, setIsUsingTelephoneAgent] = useState(Boolean(initIsUsingTelephoneAgent));
    const [phoneNumbers, setPhoneNumbers] = useState(initPhoneNumber);

    // hold music settings
    const [holdMusicFileS3Key, setHoldMusicFileS3Key] = useState(initHoldMusicFileS3Key);
    const [holdMusicTmpS3Key, setHoldMusicTmpS3Key] = useState('');
    const [holdMusicRemoved, setHoldMusicRemoved] = useState(false);
    const [holdWarningTimeMinutes, setHoldWarningTimeMinutes] = useState(initHoldWarningTimeMinutes);

    // AI tools call timeout (CR-2026-005)
    const [toolsCallTimeoutSeconds, setToolsCallTimeoutSeconds] = useState(initToolsCallTimeoutSeconds);


    // K-Board System Prompt (share link -> prompt name chip, max 1 prompt)
    const [kBoardSystemPromptLink, setKBoardSystemPromptLink] = useState(getInitKBoardSystemPrompt(projectInuseDetail));
    const [kBoardPromptDetail, setKBoardPromptDetail] = useState({});
    const [errorKBoardSystemPrompt, setErrorKBoardSystemPrompt] = useState('');
    const [isLoadingKBoardPrompt, setIsLoadingKBoardPrompt] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    const [isEdited, setIsEdited] = useState(false);
    const [isShowDialogReload, setIsShowDialogReload] = useState(false);
    const [isOpenConfirmReset, setIsOpenConfirmReset] = useState(false);
    const [closeTabIdState, setCloseTabIdState] = useRecoilState(closeTabId);
    const [isConfirmCancelTabs, setIsConfirmCancelTabs] = useState(false);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const { enqueueSnackbar } = useSnackbar();
    const [error, setError] = useState({});

    // handle init get emailResponseSettingData & listSuggestSearchEmail
    useEffect(() => {
        if (!isDisplayEmailResponseSetting()) return;
        // only query when init projectType = deskOnPublicOn or change projectType = deskOnPublicOn
        (async () => {
            try {
                setIsLoading(true);

                let params = {
                    getApiType: Constant.GET_API_PUBLIC_TYPE.GET_PROJECT_EMAIL_SETTING,
                    projectId: projectInuseDetail.id,
                    corporationId: corporationDetail.id
                };
            
                let result = await getPublicAPI(props?.API, params);
                if (result.success) {
                    const {projectDetail, suggestList} = Utils.convertJSONDataToObject(result.payload);
                    
                    const {
                        isEmailResponseSettingFunction: getIsEmailSetting,
                        projectMail: getProjectMail,
                        projectAddressName: getProjectAddressName,
                        senderEmailAddress: getSenderEmailAddress,
                        ccEmailAddressList: getCcEmailAddressList,
                        bccEmailAddressList: getBccEmailAddressList,
                        signature: getSignature
                    } = getProjectOfEmailResponseSetting(projectDetail, corporationDetail)

                    setIsEmailResponseSettingFunction(getIsEmailSetting)
                    setProjectMail(getProjectMail)
                    setProjectAddressName(getProjectAddressName)
                    setSenderEmailAddress(getSenderEmailAddress)
                    setCcEmailAddressList(getCcEmailAddressList)
                    setBccEmailAddressList(getBccEmailAddressList)
                    setSignature(getSignature)
                    setMailSettingDefault({
                        projectMail: getProjectMail.value,
                        projectAddressName: getProjectAddressName.value,
                        senderEmailAddress: getSenderEmailAddress.value,
                        signature: getSignature.value,
                        ccEmailAddressList: getCcEmailAddressList,
                        bccEmailAddressList: getBccEmailAddressList
                    });
                    
                    setListSuggestSearchEmail([...suggestList])
                }
            } catch (err) {
                console.log('GET_PROJECT_EMAIL_SETTING  err :>>', err);
            } finally {
                setIsLoading(false);
            }
        })();
    }, [projectType])

    useEffect(() => {
        if (props.tabId === closeTabIdState) {
            if (isEdited) {
                setIsConfirmCancelTabs(true);
            } else {
                closePanelTab({
                    event: null,
                    panelType: Constant.PANEL_TYPE.PROJECT_MANAGEMENT,
                    panelId: props.panelId,
                    tabId: props.tabId
                });
            }
            setCloseTabIdState(0);
        }
    }, [closeTabIdState]);

    useEffect(() => {
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'isEditedData', isEdited);
    }, [isEdited])

    useEffect(() => {
        /**
         * restore corporation ip address range. when usingIpAddressRestrict = off
         */
        const currentIpsRangeOfProjectInuse = getIpAddressRangeProject(projectInuseDetail);
        if (!Utils.isEmptyString(currentIpsRangeOfProjectInuse) && !usingIpAddressRestrict) {
            setIpAddressRange(currentIpsRangeOfProjectInuse);
        }
        
    }, [usingIpAddressRestrict]);

    const enabledIframeLinkEmbed = () => {
        if ([Constant.CORPORATION_CONTRACT_TYPE.GUEST, Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(corporationDetail?.contractType)) {
            return false;
        }

        let deskService = corporationDetail?.deskService;
        let publicWebForm = corporationDetail?.limitValue?.publicWebForm;

        // if([Constant.CORPORATION_CONTRACT_TYPE.GUEST,Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(corporationDetail?.contractType)) {
        //     const inviterSetting = Utils.convertJSONDataToObject(
        //         corporationDetail?.inviterSetting
        //     );
        //     deskService = inviterSetting.deskService;
        //     publicWebForm = inviterSetting.publicWebForm;
        // }

        return Boolean(Utils.isPublicDesk(projectInuseDetail) && deskService && publicWebForm);
    }

    const isDisplayEmailResponseSetting = () => {
        if (corporationDetail.contractType === Constant.CORPORATION_CONTRACT_TYPE.PREMIUM) {
            const corpLimitValue = corporationDetail?.limitValue;
            const emailResponseFunction = corpLimitValue?.emailResponseFunction || Constant.STATUS_SERVICE_PERMISSION.OFF;
            const isUsingEmailResponseFunction = emailResponseFunction ? Number(emailResponseFunction) === Constant.STATUS_SERVICE_PERMISSION.ON : false;
    
            return isUsingEmailResponseFunction && Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_ON === projectType;
        }
        return false;
    }

    const isDisplaySettingSynonymSearch = () => {
        if (corporationDetail?.contractType === Constant.CORPORATION_CONTRACT_TYPE.GUEST) return false;

        let synonymSearch = corporationDetail?.limitValue?.synonymSearch;
        if ([Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(corporationDetail?.contractType)) {
            const inviterSetting = Utils.convertJSONDataToObject(
                corporationDetail?.inviterSetting
            );
            synonymSearch = inviterSetting?.synonymSearch;
        }

        if (synonymSearch) {
            return true;
        }

        return false;
    }

    const handleOpenSettingIframe = () => {
        addNewPanel({
            type: Constant.PANEL_TYPE.PROJECT_MANAGEMENT,
            tabId: `${Constant.PANEL_TYPE.SYSTEM_PROJECT_SETTING_IFRAME}_${projectInuseDetail.id}`,
            projectDetail: { ...projectInuseDetail, name: currentProjectName },
            props
        });
    }

    const enabledIpAddressRestriction = () => {
        return Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_ON === projectType;
    }

    const isDisableSubmitBtn = useMemo(() => {
        const { validateBeforeSubmit, isEmptyPhoneInput, isHoldWarningTimeInvalid, isToolsCallTimeoutInvalid } = validateSubmitProjectProfile(error, projectType, isUsingTelephoneAgent, phoneNumbers, holdWarningTimeMinutes, null, toolsCallTimeoutSeconds);
        return !(isEdited && validateBeforeSubmit && !isEmptyPhoneInput && !isHoldWarningTimeInvalid && !isToolsCallTimeoutInvalid);
    }, [error, projectType, isUsingTelephoneAgent, phoneNumbers, holdWarningTimeMinutes, toolsCallTimeoutSeconds, isEdited]);

    const handleSubmitChangeProjectProfile = () => onSubmitChangeProjectProfile({
        setIsLoading,
        error,
        setError,
        projectName,
        projectType,
        usingSynonym,
        usingFileTranslation,
        usingIpAddressRestrict,
        ipAddressRange,
        enqueueSnackbar,
        userId: userDetail.id,
        projectInuseDetail,
        setProjectInuseDetail,
        setIsShowDialogReload,
        listProjectInCorp,
        setListProjectInCorp,
        listProjectOfUser,
        setListProjectOfUser,
        setIsEdited,
        setIpAddressRange,
        setUsingIpAddressRestrict,

        isEmailResponseSettingFunction,
        setIsEmailResponseSettingFunction,
        projectMail,
        setProjectMail,
        projectAddressName,
        setProjectAddressName,
        senderEmailAddress,
        setSenderEmailAddress,
        ccEmailAddressList,
        setCcEmailAddressList,
        bccEmailAddressList,
        setBccEmailAddressList,
        signature,
        setSignature,
        corporationDetail,
        reloadTicketListByPanelType,
        setIsSendEmailVerify,
        setMailSettingDefault,

        isUsingTelephoneAgent,
        phoneNumbers,
        setPhoneNumbers,
        holdMusicFileS3Key,
        holdMusicTmpS3Key,
        holdMusicRemoved,
        holdWarningTimeMinutes,
        toolsCallTimeoutSeconds,
        kBoardSystemPrompt: kBoardSystemPromptLink
    });

    const onSubmitCancelEditProjectProfile = () => {
        setIsEdited(false);
        setIsLoading(false);
        setProjectName(currentProjectName);
        setProjectType(getValueProjectServiceType(projectInuseDetail));
        setUsingSynonym(getStatusUsingSynonymProject(projectInuseDetail));
        setUsingFileTranslation(getStatusUsingFileTranslationProject(projectInuseDetail));
        setUsingIpAddressRestrict(getStatusUsingIpAddressRestrictProject(projectInuseDetail));
        setIpAddressRange(getIpAddressRangeProject(projectInuseDetail));
        setError({})

        const {
            isEmailResponseSettingFunction: getIsEmailSetting,
            projectMail: getProjectMail,
            projectAddressName: getProjectAddressName,
            senderEmailAddress: getSenderEmailAddress,
            ccEmailAddressList: getCcEmailAddressList,
            bccEmailAddressList: getBccEmailAddressList,
            signature: getSignature
        } = getProjectOfEmailResponseSetting(projectInuseDetail, corporationDetail)

        setIsEmailResponseSettingFunction(getIsEmailSetting)
        setProjectMail(getProjectMail)
        setProjectAddressName(getProjectAddressName)
        setSenderEmailAddress(getSenderEmailAddress)
        setCcEmailAddressList(getCcEmailAddressList)
        setBccEmailAddressList(getBccEmailAddressList)
        setSignature(getSignature)

        const resetPhoneData = getInitTelephoneAgentSetting(projectInuseDetail);
        setIsUsingTelephoneAgent(Boolean(resetPhoneData.initIsUsingTelephoneAgent));
        setPhoneNumbers(resetPhoneData.initPhoneNumber);
        setHoldMusicFileS3Key(resetPhoneData.initHoldMusicFileS3Key);
        setHoldMusicTmpS3Key('');
        setHoldMusicRemoved(false);
        setHoldWarningTimeMinutes(resetPhoneData.initHoldWarningTimeMinutes);
        setToolsCallTimeoutSeconds(resetPhoneData.initToolsCallTimeoutSeconds);

        const initKBoardLink = getInitKBoardSystemPrompt(projectInuseDetail);
        setKBoardSystemPromptLink(initKBoardLink);
        setErrorKBoardSystemPrompt('');
        loadKBoardPromptDetail(initKBoardLink);
    }

    // Resolve the saved K-Board prompt link into its ticket detail so the chip can render.
    const loadKBoardPromptDetail = async (link) => {
        if (Utils.isEmptyString(link)) {
            setKBoardPromptDetail({});
            return;
        }
        setIsLoadingKBoardPrompt(true);
        const { isValid, ticketDetail } = await resolveKBoardPromptTicket(link);
        if (isValid) {
            setKBoardPromptDetail(ticketDetail);
            setErrorKBoardSystemPrompt('');
        } else if (!Utils.isEmptyObject(ticketDetail)) {
            // Prompt bị soft delete hoặc save draft → giữ chip + hiển thị warning
            setKBoardPromptDetail(ticketDetail);
            setErrorKBoardSystemPrompt(Constant.AI_PROMPT_VALID_CODE.MSG_CM_INVALID_LINK);
        } else {
            // Saved prompt is no longer a valid K-Board prompt -> clear the field.
            setKBoardSystemPromptLink('');
            setKBoardPromptDetail({});
            setErrorKBoardSystemPrompt('');
        }
        setIsLoadingKBoardPrompt(false);
    };

    // Only re-resolve K-Board prompt when the saved link value actually changes (not on every projectInuseDetail update).
    const savedProjectKBoardLink = useMemo(() => {
        return getInitKBoardSystemPrompt(projectInuseDetail);
    }, [projectInuseDetail?.projectSetting]);

    useEffect(() => {
        loadKBoardPromptDetail(savedProjectKBoardLink);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [savedProjectKBoardLink]);

    const savedUsingFileTranslation = useMemo(() => {
        return getStatusUsingFileTranslationProject(projectInuseDetail);
    }, [projectInuseDetail?.id, projectInuseDetail?.projectSetting]);

    useEffect(() => {
        setUsingFileTranslation(savedUsingFileTranslation);
    }, [savedUsingFileTranslation]);
    
    return (
        <div className="aiSetting project-profile-setting">
            {isLoading ? (
                <LoadingPanel isLoading={isLoading} />
            ) : (
                <>
                    <div className="groupSetting category-active">
                        <div className="groupBtn">
                            <Button
                                variant="contained"
                                className="btn-hg32 btn-light"
                                color="primary"
                                onClick={() => handleCancelEditProjectProfile(isEdited, setIsOpenConfirmReset, error)}
                                disabled={!isEdited}
                            >
                                {trI18n('CM-BUTTON-CANCEL')}
                            </Button>

                            <Button
                                onClick={handleSubmitChangeProjectProfile}
                                disabled={isDisableSubmitBtn}
                                variant="contained"
                                className="btn-hg32 btn-primary"
                                color="primary"
                            >
                                {trI18n('COMBTN011')}
                            </Button>
                        </div>
                        {/* </div> */}
                    </div>

                    <div className="groupSetting category-active">
                        <div className="advanced-setting-title">
                            <h3>{trI18n('PROJECT_INFO')}</h3>
                        </div>
                        <div className="groupSettingContent">
                            <div className="groupSettingItem">
                                <div className="embeddedCode-label margin-bottom-5">
                                    {trI18n('PROJECT_NAME')}
                                    <span className="required">*</span>
                                </div>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    className="form-control-wrapInput form-control-hg40"
                                    value={projectName}
                                    onChange={e => onChangeProjectName(e.target.value, setProjectName, setIsEdited)}
                                    onBlur={e =>
                                        changeProjectName(e.target.value, setProjectName, error, setError, setIsEdited)
                                    }
                                    error={error.projectName ? true : false}
                                    helperText={tr(error.projectName)}
                                />
                            </div>

                            <div className="groupSettingItem">
                                <div className="embeddedCode-label margin-bottom-5">
                                    {trI18n('PROJECT_TYPE')}
                                    <span className="required">*</span>
                                </div>

                                <FormControl
                                    variant="outlined"
                                    className="form-control--wrap form-control--hg32"
                                    style={{ textAlign: 'left' }}
                                >
                                    <Select
                                        variant="outlined"
                                        MenuProps={{
                                            anchorOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'left'
                                            },
                                            transformOrigin: {
                                                vertical: 'top',
                                                horizontal: 'left'
                                            },
                                            getContentAnchorEl: null,
                                            className: 'selectDrop'
                                        }}
                                        displayEmpty
                                        defaultValue={projectType}
                                        value={projectType}
                                        onChange={event => {
                                            onChangeProjectServiceType(
                                                event,
                                                projectType,
                                                setProjectType,
                                                setIsEdited
                                            )
                                            if (projectType !== Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_ON) {
                                                const resetPhoneData = getInitTelephoneAgentSetting(projectInuseDetail);
                                                setIsUsingTelephoneAgent(Boolean(resetPhoneData.initIsUsingTelephoneAgent));
                                                setPhoneNumbers(resetPhoneData.initPhoneNumber);
                                            }
                                        }}
                                        disabled={[
                                            Constant.CORPORATION_CONTRACT_TYPE.GUEST,
                                            Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK
                                        ].includes(corporationDetail.contractType)}
                                    >
                                        <MenuItem value={Constant.PROJECT_SERVICE_TYPE.DESK_OFF}>
                                            {tr(Constant.PROJECT_SERVICE_TYPE.DESK_OFF)}
                                        </MenuItem>
                                        <MenuItem value={Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_OFF}>
                                            {tr(Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_OFF)}
                                        </MenuItem>
                                        {corporationDetail.deskService ===
                                            Constant.STATUS_SERVICE_PERMISSION.ON && (
                                                <MenuItem
                                                    value={Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_ON}
                                                >
                                                    {tr(Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_ON)}
                                                </MenuItem>
                                            )}
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                    </div>

                    {enabledIframeLinkEmbed() && (
                        <div className="groupSetting category-active setting-iframe">
                            <div className="advanced-setting-title">
                                <h3>{trI18n('LABEL-CONFIG-PUBLIC-WEB-FORM')}</h3>
                            </div>
                            <p className="iframe-link" onClick={() => handleOpenSettingIframe()}>
                                {trI18n('LABEL-GO-TO-CONFIG-PUBLIC-WEB-FORM')}
                            </p>
                        </div>
                    )}

                    {isDisplayEmailResponseSetting() && (
                        <EmailResponseSetting
                            corporationDetail={corporationDetail}
                            isEmailResponseSettingFunction={isEmailResponseSettingFunction}
                            setIsEmailResponseSettingFunction={setIsEmailResponseSettingFunction}
                            projectMail={projectMail}
                            mailSettingDefault={mailSettingDefault}
                            setProjectMail={setProjectMail}
                            projectAddressName={projectAddressName}
                            setProjectAddressName={setProjectAddressName}
                            senderEmailAddress={senderEmailAddress}
                            setSenderEmailAddress={setSenderEmailAddress}
                            ccEmailAddressList={ccEmailAddressList}
                            setCcEmailAddressList={setCcEmailAddressList}
                            bccEmailAddressList={bccEmailAddressList}
                            setBccEmailAddressList={setBccEmailAddressList}
                            signature={signature}
                            setSignature={setSignature}

                            setIsEdited={setIsEdited}
                            setError={setError}
                            listSuggestSearchEmail={listSuggestSearchEmail}
                        />
                    )}

                    {isDisplayTelephoneHoldSettings(corporationDetail) && (
                        <TelephoneAgentSetting
                            setIsEdited={setIsEdited}
                            projectType={projectType}
                            projectInuseDetail={projectInuseDetail}
                            isUsingTelephoneAgent={isUsingTelephoneAgent}
                            setIsUsingTelephoneAgent={setIsUsingTelephoneAgent}
                            phoneNumbers={phoneNumbers ?? []}
                            setPhoneNumbers={setPhoneNumbers}
                            holdMusicFileS3Key={holdMusicFileS3Key}
                            holdMusicTmpS3Key={holdMusicTmpS3Key}
                            setHoldMusicTmpS3Key={setHoldMusicTmpS3Key}
                            holdMusicRemoved={holdMusicRemoved}
                            setHoldMusicRemoved={setHoldMusicRemoved}
                            holdWarningTimeMinutes={holdWarningTimeMinutes}
                            setHoldWarningTimeMinutes={setHoldWarningTimeMinutes}
                            toolsCallTimeoutSeconds={toolsCallTimeoutSeconds}
                            setToolsCallTimeoutSeconds={setToolsCallTimeoutSeconds}
                            error={error}
                            setError={setError}
                        />
                    )}

                    {isDisplayFileTranslationSetting(corporationDetail, projectInuseDetail) && (
                        <div className="groupSetting category-active">
                            <div className="advanced-setting-title">
                                <h3>{trI18n('FILE_TRANSLATION_FUNCTION')}</h3>
                            </div>

                            <div className="groupSettingContent setting-synonym">
                                <div className="title-name setting-ai-function">
                                    {trI18n('FILE_TRANSLATION_FUNCTION')}
                                </div>

                                <div className="switch-check setting-ai-function">
                                    <input
                                        name="fileTranslation"
                                        id="setting-file-translation-switch-id"
                                        type="checkbox"
                                        checked={usingFileTranslation}
                                        onChange={() => {
                                            setUsingFileTranslation(!usingFileTranslation);
                                            setIsEdited(true);
                                        }}
                                    />
                                    <label htmlFor="setting-file-translation-switch-id"></label>
                                </div>
                            </div>
                        </div>
                    )}

                    {enabledIpAddressRestriction() && (
                        <div className="groupSetting category-active">
                            <div className="advanced-setting-title">
                                <h3>{trI18n('IP_ADDRESS_RESTRICT_FOR_PUBLIC_FUNCTION')}</h3>
                            </div>
                            <div className="groupSettingContent setting-synonym">
                                <div className="title-name setting-ai-function">
                                    {trI18n('APPLY_IP_ADDRESS_RESTRICTION')}
                                </div>
                                <div className="switch-check setting-ai-function">
                                    <input
                                        name="ipaddressRestrict"
                                        id="setting-ipaddress-switch-id"
                                        type="checkbox"
                                        checked={usingIpAddressRestrict}
                                        onChange={e => {
                                            let usingIpAddressRestrictValue = !usingIpAddressRestrict;
                                            onChangeUsingIpAddressRestrict(usingIpAddressRestrictValue, setUsingIpAddressRestrict, error, setError, setIsEdited);
                                            setIpAddressRange(ipAddressRangeDefault);
                                        }}
                                    />
                                    <label htmlFor="setting-ipaddress-switch-id"></label>
                                </div>
                            </div>
                            <div className="groupSettingItem ipaddress-range">
                                <div className="embeddedCode-label margin-bottom-5">
                                    {trI18n('IP_ADDRESS_SETTING_DESCRIPTION')}
                                </div>
                                <TextField
                                    placeholder={trI18n('IP_ADDRESS_RANGE_PLACEHOLDER')}
                                    multiline
                                    fullWidth
                                    variant="outlined"
                                    minRows={5}
                                    maxRows={5}
                                    className="form-control-wrapInput form-control-hg40"
                                    value={ipAddressRange}
                                    onChange={e => onChangeIpAddressRange(e.target.value, setIpAddressRange, setIsEdited)}
                                    onBlur={e =>
                                        changeIpAddressRange(e.target.value, setIpAddressRange, error, setError, setIsEdited)
                                    }
                                    disabled={!usingIpAddressRestrict}
                                    error={error.ipAddressRange ? true : false}
                                    helperText={error.ipAddressRange}
                                />
                            </div>
                        </div>
                    )}

                    {Utils.convertJSONDataToObject(corporationDetail?.limitValue)?.kBoard === Constant.STATUS_SERVICE_PERMISSION.ON && (
                    <div className="groupSetting category-active" style={{ position: 'relative' }}>
                        <LoadingPanel isLoading={isLoadingKBoardPrompt} />
                        <div className="advanced-setting-title">
                            <h3>{trI18n('LABEL-K-BOARD-SYSTEM-PROMPT')}</h3>
                        </div>
                        <div className="groupSettingItem">
                            <div className="prompt-basic-chip-ai-auto org-profile-system-prompt-input prompt-basic-chip-ai-auto-column">
                                {(!kBoardSystemPromptLink ||
                                (kBoardSystemPromptLink && errorKBoardSystemPrompt) ||
                                Utils.isEmptyObject(kBoardPromptDetail)) ? (
                                    <>
                                        <TextField
                                            fullWidth
                                            className="form-control-input form-control-wrapInput form-control-hg32 chip-org-profile"
                                            variant="outlined"
                                            spellCheck={false}
                                            autoComplete="seriously-please-don't-autocomplete"
                                            type="text"
                                            value={kBoardSystemPromptLink || ''}
                                            disabled={isLoadingKBoardPrompt}
                                            onChange={e => {
                                                setKBoardSystemPromptLink(e.target.value);
                                            }}
                                            onBlur={e =>
                                                handleOnBlurKBoardSystemPrompt(
                                                    e,
                                                    setKBoardSystemPromptLink,
                                                    setKBoardPromptDetail,
                                                    setErrorKBoardSystemPrompt,
                                                    setIsLoadingKBoardPrompt,
                                                    setIsEdited
                                                )
                                            }
                                            helperText={''}
                                            error={!Utils.isEmptyString(errorKBoardSystemPrompt)}
                                        />
                                        {!Utils.isEmptyString(errorKBoardSystemPrompt) && (
                                            <div>
                                                <span className="text-warning-chat-ai text-warning-model">
                                                    {trI18n(errorKBoardSystemPrompt)}
                                                </span>
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    <Chip
                                        style={{ width: '100%', maxWidth: '100%', overflow: 'hidden' }}
                                        label={
                                            <OverflowTooltipContent
                                                text={
                                                    Utils.convertJSONDataToObject(kBoardPromptDetail?.outline)?.jp
                                                }
                                                style={{ fontWeight: 500, fontSize: '14px', color: '#2D72D2' }}
                                            />
                                        }
                                        onClick={() => {
                                            if (Utils.isEmptyObject(kBoardPromptDetail)) return;
                                            openPromptTicketPanel(
                                                setIsLoading,
                                                userDetail,
                                                kBoardPromptDetail.id,
                                                projectInuseDetail,
                                                setIsShowDialogReload,
                                                addNewPanel,
                                                null
                                            );
                                        }}
                                        onDelete={() =>
                                            handleRemoveKBoardSystemPrompt(
                                                setKBoardSystemPromptLink,
                                                setKBoardPromptDetail,
                                                setErrorKBoardSystemPrompt,
                                                setIsEdited
                                            )
                                        }
                                        deleteIcon={
                                            <img
                                                className="basic-chip-delete-icon"
                                                src="/assets/image/delete-icon-rounded.svg"
                                                alt="delete"
                                            />
                                        }
                                        className={`basic-chip chip-ai-auto top-4px`}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                    )}

                    {isDisplaySettingSynonymSearch() && (
                        <div className="groupSetting category-active">
                            <div className="advanced-setting-title">
                                <h3>{tr('類義語検索機能')}</h3>
                            </div>

                            <div className="groupSettingContent setting-synonym">
                                <div className="title-name setting-ai-function">
                                    {tr('類義語検索機能を使用する')}
                                </div>

                                <div className="switch-check setting-ai-function">
                                    <input
                                        name="chatAI"
                                        id="setting-synonym-switch-id"
                                        type="checkbox"
                                        checked={usingSynonym}
                                        onChange={e => {
                                            let usingSynonymValue = !usingSynonym;
                                            setUsingSynonym(usingSynonymValue);
                                            setIsEdited(true);
                                        }}
                                    />
                                    <label htmlFor="setting-synonym-switch-id"></label>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}

            <ConfirmDialog
                isOpen={isOpenConfirmReset}
                msgConfirm={trI18n('MSG-CM-CONFIRM-EXIT-PAGE-WITHOUT-SAVING')}
                okCallBack={() => {
                    setIsOpenConfirmReset(false);
                    handleSubmitChangeProjectProfile();
                }}
                closeCallBack={() => {
                    onSubmitCancelEditProjectProfile();
                    setIsOpenConfirmReset(false);
                }}
                cancelCallBack={() => {
                    setIsOpenConfirmReset(false);
                }}
                textSubmit={trI18n('COMBTN002')}
                textClose={trI18n('COMBTN007')}
                textCancel={trI18n('COMBTN001')}
                isShowClassnameButton={false}
                okButtonStyle={{ backgroundColor: '#3D547B', color: '#FFFFFF' }}
                closeButtonStyle={{ backgroundColor: '#CC4733', color: '#FFFFFF' }}
                cancelButtonStyle={{ backgroundColor: '#F2F3F5', color: '#5D636F' }}
            />

            <ConfirmDialog
                isOpen={isShowDialogReload}
                msgConfirm={trI18n('COMMSG030')}
                okCallBack={() => {
                    window.location.reload();
                }}
            />

            <ConfirmDialog
                isOpen={isSendEmailVerify}
                msgConfirm={trI18n('MSG_SEND_VERIFY_EMAIL_CONFIRM')}
                okCallBack={() => setIsSendEmailVerify(false)}
            />

            <ConfirmDialog
                isOpen={isConfirmCancelTabs}
                msgConfirm={trI18n('MSG-CM-CONFIRM-EXIT-PAGE-WITHOUT-SAVING')}
                okCallBack={() => {
                    setIsConfirmCancelTabs(false);
                    handleSubmitChangeProjectProfile()
                }}
                closeCallBack={() => {
                    setIsConfirmCancelTabs(false);
                    closePanelTab({
                        event: null,
                        panelType: Constant.PANEL_TYPE.PROJECT_MANAGEMENT,
                        panelId: props.panelId,
                        tabId: props.tabId
                    });
                }}
                cancelCallBack={() => {
                    setIsConfirmCancelTabs(false);
                }}
                textSubmit={trI18n('COMBTN002')}
                textClose={trI18n('COMBTN007')}
                textCancel={trI18n('COMBTN001')}
                isShowClassnameButton={false}
                okButtonStyle={{ backgroundColor: '#3D547B', color: '#FFFFFF' }}
                closeButtonStyle={{ backgroundColor: '#CC4733', color: '#FFFFFF' }}
                cancelButtonStyle={{ backgroundColor: '#F2F3F5', color: '#5D636F' }}
            />
        </div>
    );
}
